var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { SESSION_LENGTHS } from './useLitSession';
import { toast } from 'sonner';
import useWalletAuthSig from './useWalletAuthSig';
import { useSession } from '@/contexts/LitSessionProvider';
import IpfsHash from 'ipfs-only-hash';
import { fetchDBUser, updateDBUser } from '@/lib/db/DBUserHelpers';
import { fetchDBCloudWallet, updateDbCloudWallet, } from '@/lib/db/DBCloudWalletHelpers';
import { checkMFA } from '@/lib/auth/mfa';
import { getPKPSessionSig } from '@/lib/auth/sessionSig';
import { getSession as getNextSession, signIn as nextSignIn } from 'next-auth/react';
import { AuthMethodType } from '@lit-protocol/constants';
import { Keypair } from '@solana/web3.js';
import { mintPKP } from '@/lib/auth/mintPKP';
import { ExtendedProviderType } from '@shared/types/lit-protocol';
import { createDBEncryptedWallet, fetchDBEncryptedWallets, } from '@/lib/db/DBEncryptedWalletsHelpers';
import { ethers } from 'ethers';
import { fetchIPFSData } from '@/lib/misc/fetchIPFSData';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { getUrls } from '@shared/utils/config/environment';
import { storeEncryptedKey } from '@lit-protocol/wrapped-keys/src/lib/api';
import { useQueryClient } from '@tanstack/react-query';
import { useLocalStorage } from 'usehooks-ts';
import { useIsMobile } from '../utilities/use-mobile';
import { slackLogger } from '@shared/utils/off-chain/slack-logger';
export var delay = function (ms) { return new Promise(function (res) { return setTimeout(res, ms); }); };
export default function useLitAuth(_a) {
    var _this = this;
    var authType = _a.authType;
    var router = useRouter();
    var isMobile = useIsMobile();
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useSession(), clients = _c.clients, setAllPKPs = _c.setAllPKPs, setPKP = _c.setPKP, activeProviderType = _c.activeProviderType, litNetwork = _c.litNetwork, currentAuthMethod = _c.currentAuthMethod, setCurrentAuthMethod = _c.setCurrentAuthMethod, setMFAInfo = _c.setMFAInfo, setLitSession = _c.setLitSession, sessionLength = _c.sessionLength, connectedWalletAddress = _c.connectedWalletAddress, setDecryptedWallets = _c.setDecryptedWallets, clearLitSession = _c.clearLitSession, decryptedWallets = _c.decryptedWallets;
    var _d = useMixpanel(), LogToMixpanel = _d.LogToMixpanel, EVENTS = _d.EVENTS, CATEGORIES = _d.CATEGORIES;
    var queryClient = useQueryClient();
    var _e = useLocalStorage("progressBar-".concat(authType), 0), progressBar = _e[0], setProgressBar = _e[1];
    var _f = useWalletAuthSig(), authSig = _f.authSig, sign = _f.sign;
    var retry = useRef(0);
    var hasInit = useRef(false);
    var _g = useLocalStorage('startDecryption', false), startDecryption = _g[0], setStartDecryption = _g[1];
    function authIn() {
        return __awaiter(this, void 0, Promise, function () {
            var pkps, authMethod, needsMint, nonce, authSigResponse, provider, e_1;
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        //clear any previous session when logging in
                        clearLitSession(true);
                        _j.label = 1;
                    case 1:
                        _j.trys.push([1, 14, 15, 16]);
                        setLoading(true);
                        console.log('SIGN IN START', 'authtype', authType, 'clients', (_a = clients === null || clients === void 0 ? void 0 : clients.litAuthClients) === null || _a === void 0 ? void 0 : _a[authType]);
                        authMethod = null;
                        needsMint = true;
                        if (!(authType === ExtendedProviderType.EthWallet)) return [3 /*break*/, 5];
                        return [4 /*yield*/, ((_b = clients === null || clients === void 0 ? void 0 : clients.litNodeClient) === null || _b === void 0 ? void 0 : _b.getLatestBlockhash())];
                    case 2:
                        nonce = _j.sent();
                        return [4 /*yield*/, sign({
                                nonce: nonce,
                                sessionLength: sessionLength || SESSION_LENGTHS['1 week'],
                            })];
                    case 3:
                        authSigResponse = _j.sent();
                        if (authSigResponse.error) {
                            throw new Error(authSigResponse.error);
                        }
                        authMethod = {
                            authMethodType: AuthMethodType.EthWallet,
                            accessToken: JSON.stringify(authSigResponse.authSig),
                        };
                        provider = (_d = (_c = clients === null || clients === void 0 ? void 0 : clients.litAuthClients) === null || _c === void 0 ? void 0 : _c[authType]) === null || _d === void 0 ? void 0 : _d.provider;
                        return [4 /*yield*/, provider.fetchPKPsThroughRelayer(authMethod)];
                    case 4:
                        pkps = _j.sent();
                        console.log('wallet found pkps', pkps, 'ethWallet', (_e = pkps[pkps.length - 1]) === null || _e === void 0 ? void 0 : _e.ethAddress);
                        if (pkps.length > 0) {
                            needsMint = false;
                            setAllPKPs(pkps);
                            setPKP(pkps[0]);
                            pkps = pkps;
                        }
                        return [3 /*break*/, 13];
                    case 5:
                        if (!(authType === ExtendedProviderType.Twitter)) return [3 /*break*/, 7];
                        return [4 /*yield*/, nextSignIn('twitter')];
                    case 6:
                        _j.sent();
                        return [3 /*break*/, 13];
                    case 7:
                        if (!(authType === ExtendedProviderType.Apple)) return [3 /*break*/, 9];
                        return [4 /*yield*/, nextSignIn('apple')];
                    case 8:
                        _j.sent();
                        return [3 /*break*/, 13];
                    case 9:
                        if (!(authType === ExtendedProviderType.GoogleG)) return [3 /*break*/, 11];
                        console.log('signing in with google');
                        return [4 /*yield*/, nextSignIn('google')];
                    case 10:
                        _j.sent();
                        return [3 /*break*/, 13];
                    case 11: return [4 /*yield*/, ((_h = (_g = (_f = clients === null || clients === void 0 ? void 0 : clients.litAuthClients) === null || _f === void 0 ? void 0 : _f[authType]) === null || _g === void 0 ? void 0 : _g.provider) === null || _h === void 0 ? void 0 : _h.signIn())];
                    case 12:
                        authMethod = _j.sent();
                        _j.label = 13;
                    case 13:
                        setCurrentAuthMethod(authMethod);
                        setMFAInfo(null);
                        console.log('SIGN IN SUCCESS', authMethod, 'authType', authType, 'network', litNetwork);
                        return [2 /*return*/, {
                                authMethod: authMethod,
                                needsMint: needsMint,
                                pkp: pkps === null || pkps === void 0 ? void 0 : pkps[0],
                            }];
                    case 14:
                        e_1 = _j.sent();
                        console.log('SIGN IN ERROR', e_1);
                        slackLogger({
                            type: 'APPLICATION_ERROR',
                            payload: {
                                type: 'SIGN_IN_ERROR',
                                error: e_1.message,
                                stack: e_1.stack,
                                pkps: pkps,
                            },
                        });
                        LogToMixpanel({
                            category: CATEGORIES.error,
                            eventName: EVENTS.error.authError,
                            pkp: pkps === null || pkps === void 0 ? void 0 : pkps[0],
                            metaData: {
                                type: 'SIGN_IN_ERROR',
                                error: e_1.message,
                                stack: e_1.stack,
                                pkps: pkps,
                            }
                        });
                        setCurrentAuthMethod(null);
                        setMFAInfo(null);
                        return [2 /*return*/, null];
                    case 15:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 16: return [2 /*return*/, null];
                }
            });
        });
    }
    var handleRedirect = useCallback(function (providerName, token) { return __awaiter(_this, void 0, void 0, function () {
        var startTime, authMethod, provider, pkps, pkp, nextSession, twitterCreds, email, name, existingAddressesResponse, existingAddresses_1, returnedPkp, dbCloudWallet, userId, authMethodId, userData, userUpdate, err_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    startTime = Date.now();
                    _m.label = 1;
                case 1:
                    _m.trys.push([1, 28, 29, 30]);
                    setLoading(true);
                    setProgressBar(function (prev) { return 10; });
                    console.log('WUJI HANDLE REDIRECT START', providerName, 'clients', clients === null || clients === void 0 ? void 0 : clients.litAuthClients);
                    if (!!providerName) return [3 /*break*/, 4];
                    if (!(retry.current == 0)) return [3 /*break*/, 3];
                    retry.current = 1;
                    return [4 /*yield*/, authIn()];
                case 2:
                    _m.sent();
                    return [2 /*return*/];
                case 3:
                    alert('Error signing in, please try again');
                    return [2 /*return*/];
                case 4:
                    console.log('WUJI auth in time', Date.now() - startTime);
                    startTime = Date.now();
                    if (!(clients === null || clients === void 0 ? void 0 : clients.clientCreated))
                        throw new Error('LitAuthClient is not initialized');
                    return [4 /*yield*/, getNextSession()];
                case 5:
                    nextSession = _m.sent();
                    console.log('WUJI, nextSession', nextSession, startTime - Date.now());
                    twitterCreds = null;
                    email = (_a = nextSession === null || nextSession === void 0 ? void 0 : nextSession.user) === null || _a === void 0 ? void 0 : _a.email;
                    name = (_b = nextSession === null || nextSession === void 0 ? void 0 : nextSession.user) === null || _b === void 0 ? void 0 : _b.name;
                    if (!(providerName === 'apple')) return [3 /*break*/, 7];
                    console.log('starting apple sign in');
                    provider = (_d = (_c = clients === null || clients === void 0 ? void 0 : clients.litAuthClients) === null || _c === void 0 ? void 0 : _c[providerName]) === null || _d === void 0 ? void 0 : _d.provider;
                    authMethod = {
                        authMethodType: AuthMethodType.AppleJwt,
                        accessToken: token,
                    };
                    return [4 /*yield*/, provider.fetchPKPsThroughRelayer(authMethod)];
                case 6:
                    pkps = _m.sent();
                    pkp = pkps === null || pkps === void 0 ? void 0 : pkps[0];
                    return [3 /*break*/, 12];
                case 7:
                    if (!(providerName === 'genius-google')) return [3 /*break*/, 9];
                    console.log('starting genius-google sign in');
                    provider = (_f = (_e = clients === null || clients === void 0 ? void 0 : clients.litAuthClients) === null || _e === void 0 ? void 0 : _e['google']) === null || _f === void 0 ? void 0 : _f.provider;
                    authMethod = {
                        authMethodType: AuthMethodType.GoogleJwt,
                        accessToken: token,
                    };
                    return [4 /*yield*/, provider.fetchPKPsThroughRelayer(authMethod)];
                case 8:
                    pkps = _m.sent();
                    pkp = pkps === null || pkps === void 0 ? void 0 : pkps[0];
                    return [3 /*break*/, 12];
                case 9:
                    provider = (_h = (_g = clients === null || clients === void 0 ? void 0 : clients.litAuthClients) === null || _g === void 0 ? void 0 : _g[providerName]) === null || _h === void 0 ? void 0 : _h.provider;
                    return [4 /*yield*/, provider.authenticate()];
                case 10:
                    authMethod = _m.sent();
                    return [4 /*yield*/, provider.fetchPKPsThroughRelayer(authMethod)];
                case 11:
                    pkps = _m.sent();
                    pkp = pkps === null || pkps === void 0 ? void 0 : pkps[0];
                    _m.label = 12;
                case 12:
                    startTime = Date.now();
                    return [4 /*yield*/, fetch("/api/auth/checkAccount?ethAddresses=".concat(pkps === null || pkps === void 0 ? void 0 : pkps.map(function (x) { return x.ethAddress; }).join(',')), {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 13:
                    existingAddressesResponse = _m.sent();
                    return [4 /*yield*/, existingAddressesResponse.json()];
                case 14:
                    existingAddresses_1 = _m.sent();
                    console.log('WUJI get existing addresses time', Date.now() - startTime, existingAddresses_1);
                    if (existingAddresses_1 === null || existingAddresses_1 === void 0 ? void 0 : existingAddresses_1.existingEthAddress) {
                        pkp = pkps === null || pkps === void 0 ? void 0 : pkps.find(function (x) { var _a, _b; return ((_a = x.ethAddress) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_b = existingAddresses_1 === null || existingAddresses_1 === void 0 ? void 0 : existingAddresses_1.existingEthAddress) === null || _b === void 0 ? void 0 : _b.toLowerCase()); });
                    }
                    else if (existingAddresses_1.error) {
                        throw new Error(existingAddresses_1.error);
                    }
                    else {
                        pkps = [];
                        pkp = {};
                    }
                    setPKP(__assign(__assign({}, pkp), { firstName: name === null || name === void 0 ? void 0 : name.split('%20')[0], lastName: name === null || name === void 0 ? void 0 : name.split('%20')[1], email: email }));
                    setAllPKPs(pkps);
                    setCurrentAuthMethod(authMethod);
                    setMFAInfo(null);
                    if (!((pkps === null || pkps === void 0 ? void 0 : pkps.length) === 0 || !pkp)) return [3 /*break*/, 19];
                    return [4 /*yield*/, mint(authMethod)];
                case 15:
                    returnedPkp = _m.sent();
                    if (!(returnedPkp === null || returnedPkp === void 0 ? void 0 : returnedPkp.ethAddress)) return [3 /*break*/, 17];
                    return [4 /*yield*/, createSession(returnedPkp, authMethod)];
                case 16:
                    _m.sent();
                    return [3 /*break*/, 18];
                case 17:
                    console.log('Failed to mint PKP');
                    _m.label = 18;
                case 18: return [3 /*break*/, 21];
                case 19:
                    console.log('creating session after redirect for', pkp);
                    LogToMixpanel({
                        pkp: pkp,
                        category: CATEGORIES.auth,
                        eventName: EVENTS.auth.login,
                        metaData: {
                            type: authType,
                        },
                    });
                    return [4 /*yield*/, createSession(pkp, authMethod, twitterCreds)];
                case 20:
                    _m.sent();
                    _m.label = 21;
                case 21: return [4 /*yield*/, fetchDBCloudWallet()];
                case 22:
                    dbCloudWallet = _m.sent();
                    userId = (_j = dbCloudWallet === null || dbCloudWallet === void 0 ? void 0 : dbCloudWallet.data) === null || _j === void 0 ? void 0 : _j.user_id;
                    console.log('WUJI dbCloudWallet', dbCloudWallet, 'userId', userId);
                    return [4 /*yield*/, (provider === null || provider === void 0 ? void 0 : provider.getAuthMethodId(authMethod))];
                case 23:
                    authMethodId = _m.sent();
                    if (!!((_k = dbCloudWallet === null || dbCloudWallet === void 0 ? void 0 : dbCloudWallet.data) === null || _k === void 0 ? void 0 : _k.user_id)) return [3 /*break*/, 26];
                    return [4 /*yield*/, fetchDBUser({ creationAuthMethodId: authMethodId })];
                case 24:
                    userData = _m.sent();
                    userId = (_l = userData === null || userData === void 0 ? void 0 : userData.data) === null || _l === void 0 ? void 0 : _l.id;
                    console.log('WUJI userData', userData, userId);
                    return [4 /*yield*/, updateDbCloudWallet({
                            user_id: userId,
                            eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                        })];
                case 25:
                    dbCloudWallet = _m.sent();
                    console.log('userData update', dbCloudWallet, userId);
                    _m.label = 26;
                case 26:
                    queryClient.invalidateQueries({ queryKey: ['cloudUserData'] });
                    return [4 /*yield*/, updateDBUser({
                            id: userId,
                            first_name: name === null || name === void 0 ? void 0 : name.split('%20')[0],
                            last_name: name === null || name === void 0 ? void 0 : name.split('%20')[1],
                            email: email,
                        })];
                case 27:
                    userUpdate = _m.sent();
                    if (isMobile) {
                        router.push('/portfolio');
                    }
                    return [3 /*break*/, 30];
                case 28:
                    err_1 = _m.sent();
                    slackLogger({
                        type: 'APPLICATION_ERROR',
                        payload: {
                            type: 'SIGN_IN_HANDLE_REDIRECT_ERROR',
                            error: err_1.message,
                            stack: err_1.stack,
                            pkps: pkps,
                        },
                    });
                    LogToMixpanel({
                        category: CATEGORIES.error,
                        eventName: EVENTS.error.authError,
                        pkp: pkps === null || pkps === void 0 ? void 0 : pkps[0],
                        metaData: {
                            type: 'SIGN_IN_HANDLE_REDIRECT_ERROR',
                            error: err_1.message,
                            stack: err_1.stack,
                            pkps: pkps,
                        }
                    });
                    console.log('WUJI HANDLE REDIRECT ERROR', err_1);
                    return [3 /*break*/, 30];
                case 29:
                    console.log('WUJI HANDLE REDIRECT TIME', Date.now() - startTime);
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 30: return [2 /*return*/];
            }
        });
    }); }, [router, clients === null || clients === void 0 ? void 0 : clients.litAuthClients]);
    // Automatically attempt to handle a redirect from a sign-in operation
    useEffect(function () {
        // Automatically attempt to handle a redirect from a sign-in operation
        var attemptRedirectHandling = function () { return __awaiter(_this, void 0, void 0, function () {
            var startTime, cookies, loginParams, providerName_1, providerType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = Date.now();
                        if (!(clients === null || clients === void 0 ? void 0 : clients.litAuthClients)) return [3 /*break*/, 3];
                        cookies = require('browser-cookies');
                        loginParams = cookies.get('next-auth.login-params');
                        if (!loginParams) return [3 /*break*/, 3];
                        loginParams = JSON.parse(loginParams);
                        providerName_1 = loginParams.provider;
                        providerType = function () {
                            switch (providerName_1 === null || providerName_1 === void 0 ? void 0 : providerName_1.toLowerCase()) {
                                case 'genius-google':
                                    return ExtendedProviderType.GoogleG;
                                case 'google':
                                    return ExtendedProviderType.Google;
                                case 'apple':
                                    return ExtendedProviderType.Apple;
                                case 'discord':
                                    return ExtendedProviderType.Discord;
                                case 'twitter':
                                    return ExtendedProviderType.Twitter;
                                default:
                                    return ExtendedProviderType.EthWallet;
                            }
                        };
                        console.log('WUJI attemptRedirectHandling TIME', Date.now() - startTime);
                        if (!providerName_1 || authType !== providerType())
                            return [2 /*return*/];
                        if (!!hasInit.current) return [3 /*break*/, 2];
                        hasInit.current = true;
                        cookies.erase('next-auth.login-params');
                        return [4 /*yield*/, handleRedirect(providerName_1, loginParams.token)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        attemptRedirectHandling();
    }, [clients === null || clients === void 0 ? void 0 : clients.litAuthClients, activeProviderType, handleRedirect]); // Dependencies updated to reflect the refactored state management
    var mint = function (authMethod) { return __awaiter(_this, void 0, Promise, function () {
        var authMethodToUse, provider, newPKP, err_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setProgressBar(function (prev) { return 15; });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    setLoading(true);
                    console.log('MINT START', { authType: authType, currentAuthMethod: currentAuthMethod, authMethod: authMethod });
                    if (!clients.litAuthClients)
                        throw new Error('Missing initialization');
                    if (!currentAuthMethod && !authMethod)
                        throw new Error('Missing authMethod');
                    if (!currentAuthMethod && authMethod) {
                        setCurrentAuthMethod(authMethod);
                    }
                    authType = authType === ExtendedProviderType.GoogleG ? ExtendedProviderType.Google : authType;
                    authMethodToUse = currentAuthMethod || authMethod;
                    provider = (_b = (_a = clients === null || clients === void 0 ? void 0 : clients.litAuthClients) === null || _a === void 0 ? void 0 : _a[authType]) === null || _b === void 0 ? void 0 : _b.provider;
                    return [4 /*yield*/, mintPKP(ExtendedProviderType.EthWallet, authMethodToUse, provider, ExtendedProviderType.EthWallet ? connectedWalletAddress : null, setProgressBar)];
                case 2:
                    newPKP = _c.sent();
                    setProgressBar(function (prev) { return 30; });
                    LogToMixpanel({
                        pkp: newPKP,
                        category: CATEGORIES.auth,
                        eventName: EVENTS.auth.signup,
                        metaData: {
                            type: authType,
                        },
                    });
                    setPKP(newPKP);
                    return [2 /*return*/, newPKP];
                case 3:
                    err_2 = _c.sent();
                    slackLogger({
                        type: 'APPLICATION_ERROR',
                        payload: {
                            type: 'MINT_ERROR',
                            error: err_2.message,
                            stack: err_2.stack,
                            authMethodType: authMethod === null || authMethod === void 0 ? void 0 : authMethod.authMethodType,
                        },
                    });
                    LogToMixpanel({
                        category: CATEGORIES.error,
                        eventName: EVENTS.error.authError,
                        pkp: null,
                        metaData: {
                            type: 'MINT_ERROR',
                            error: err_2.message,
                            stack: err_2.stack,
                            authMethodType: authMethod === null || authMethod === void 0 ? void 0 : authMethod.authMethodType,
                        }
                    });
                    console.log('MINT ERROR', err_2);
                    return [2 /*return*/, null];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var createSession = function (pkp, overrideAuthMethod, twitterCredentials) { return __awaiter(_this, void 0, Promise, function () {
        var startTime, authMethodToUse, provider, startime0, sessionSigs, sessionSigs0_1, nextSession, updateSessionResult, _mfaInfo, encryptedWallets, hasEncryptedSolanaWallet_1, hasEncryptedEvmWallet_1, solanaAddress_1, solanaCiphertext_1, solanaDataToEncryptHash_1, evmAddress_1, evmCiphertext_1, evmDataToEncryptHash_1, code, ipfsHash, solanaWalletPromise, evmWalletPromise, wallet, keypair, privateKey, privateKey, _a, newEvmWalletRes, newSolanaWalletRes, parsedRes, createDbEncryptedWallet, addWalletToIndexer, parsedRes, createDbEncryptedWallet, addWalletToIndexer, backupEVMBackupKeyToLitPromise, backupSolanaBackupKeyToLitPromise, _b, backupEVMBackupKeyToLit, backupSolanaBackupKeyToLit, e_2, err_3;
        var _this = this;
        var _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    startTime = Date.now();
                    setProgressBar(function (prev) { return 30; });
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 26, 27, 28]);
                    setLoading(true);
                    authMethodToUse = overrideAuthMethod || currentAuthMethod;
                    provider = (_d = (_c = clients === null || clients === void 0 ? void 0 : clients.litAuthClients) === null || _c === void 0 ? void 0 : _c[authType]) === null || _d === void 0 ? void 0 : _d.provider;
                    // const authMethodId = await provider.getAuthMethodId(authMethodToUse!);
                    console.log('CREATE SESSION START', pkp, 'currentAuthMethod', authMethodToUse, twitterCredentials);
                    startime0 = Date.now();
                    return [4 /*yield*/, getPKPSessionSig(pkp, authMethodToUse, clients.litNodeClient, sessionLength || SESSION_LENGTHS['1 week'])];
                case 2:
                    sessionSigs = _g.sent();
                    return [4 /*yield*/, getPKPSessionSig(pkp, authMethodToUse, clients.litNodeClient, SESSION_LENGTHS['10 minutes'])];
                case 3:
                    sessionSigs0_1 = _g.sent();
                    setProgressBar(function (prev) { return 40; });
                    console.log('WUJI CREATE SESSIONSIG TIME', Date.now() - startime0, startime0 - startTime);
                    setLitSession(sessionSigs);
                    setProgressBar(function (prev) { return 50; });
                    startime0 = Date.now();
                    return [4 /*yield*/, getNextSession()];
                case 4:
                    nextSession = _g.sent();
                    console.log('WUJI nextSession', nextSession);
                    if (!nextSession) return [3 /*break*/, 6];
                    return [4 /*yield*/, fetch('/api/auth/update-session', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ swieAuthSig: null, messageSig: null, sessionSig: sessionSigs }),
                        })];
                case 5:
                    updateSessionResult = _g.sent();
                    console.log('WUJI updateSessionResult', JSON.stringify(updateSessionResult, null, 2));
                    _g.label = 6;
                case 6:
                    console.log('WUJI nextauthtime', Date.now() - startime0);
                    startime0 = Date.now();
                    setProgressBar(function (prev) { return 65; });
                    return [4 /*yield*/, checkMFA(pkp, sessionSigs, authMethodToUse)];
                case 7:
                    _mfaInfo = _g.sent();
                    console.log('WUJI CREATE MFA TIME', Date.now() - startime0);
                    setProgressBar(function (prev) { return 70; });
                    setMFAInfo(_mfaInfo);
                    startime0 = Date.now();
                    return [4 /*yield*/, fetchDBEncryptedWallets({})];
                case 8:
                    encryptedWallets = (_g.sent()).data;
                    hasEncryptedSolanaWallet_1 = encryptedWallets === null || encryptedWallets === void 0 ? void 0 : encryptedWallets.find(function (x) { return x.type === 'Solana'; });
                    hasEncryptedEvmWallet_1 = encryptedWallets === null || encryptedWallets === void 0 ? void 0 : encryptedWallets.find(function (x) { return x.type === 'EVM' && x.imported == false; });
                    solanaAddress_1 = null;
                    solanaCiphertext_1 = null;
                    solanaDataToEncryptHash_1 = null;
                    evmAddress_1 = null;
                    evmCiphertext_1 = null;
                    evmDataToEncryptHash_1 = null;
                    if (!(!hasEncryptedSolanaWallet_1 || !hasEncryptedEvmWallet_1)) return [3 /*break*/, 19];
                    return [4 /*yield*/, fetchIPFSData('Qmdn3AEqUf3WfS4L5XLdAtqm8eDvkLvHRDZJYfEW9vdTzf')];
                case 9:
                    code = _g.sent();
                    return [4 /*yield*/, IpfsHash.of(code)];
                case 10:
                    ipfsHash = _g.sent();
                    solanaWalletPromise = void 0;
                    evmWalletPromise = void 0;
                    wallet = void 0;
                    keypair = void 0;
                    if (!hasEncryptedEvmWallet_1) {
                        wallet = ethers.Wallet.createRandom();
                        evmAddress_1 = wallet.address;
                        privateKey = wallet.privateKey;
                        console.log('evmAddress: ', evmAddress_1);
                        evmWalletPromise = clients.litNodeClient.executeJs({
                            code: code,
                            sessionSigs: sessionSigs,
                            jsParams: {
                                privateKey: privateKey,
                                encrypt: true,
                                ethAddress: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                                ipfsHash: ipfsHash,
                            },
                        });
                    }
                    if (!hasEncryptedSolanaWallet_1) {
                        keypair = Keypair.generate();
                        solanaAddress_1 = keypair.publicKey.toBase58();
                        privateKey = keypair.secretKey.toString();
                        solanaWalletPromise = clients.litNodeClient.executeJs({
                            code: code,
                            sessionSigs: sessionSigs,
                            jsParams: {
                                privateKey: privateKey,
                                encrypt: true,
                                ethAddress: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                                ipfsHash: ipfsHash,
                            },
                        });
                    }
                    return [4 /*yield*/, Promise.all([
                            evmWalletPromise,
                            solanaWalletPromise,
                        ])];
                case 11:
                    _a = _g.sent(), newEvmWalletRes = _a[0], newSolanaWalletRes = _a[1];
                    setProgressBar(function (prev) { return 75; });
                    if (!newEvmWalletRes) return [3 /*break*/, 15];
                    parsedRes = JSON.parse(newEvmWalletRes.response);
                    console.log('parsedRes: ', parsedRes);
                    evmCiphertext_1 = parsedRes.ciphertext;
                    evmDataToEncryptHash_1 = parsedRes.dataToEncryptHash;
                    return [4 /*yield*/, createDBEncryptedWallet({
                            pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                            type: 'EVM',
                            address: evmAddress_1,
                            ciphertext: evmCiphertext_1,
                            data_to_encrypt_hash: evmDataToEncryptHash_1,
                            imported: false,
                        })];
                case 12:
                    createDbEncryptedWallet = _g.sent();
                    hasEncryptedEvmWallet_1 = createDbEncryptedWallet === null || createDbEncryptedWallet === void 0 ? void 0 : createDbEncryptedWallet.data;
                    console.log('evm wallet saved to db', createDbEncryptedWallet);
                    return [4 /*yield*/, fetch("".concat(getUrls().INDEXER_URL, "/portfolio/start-tracking?wallet=").concat(evmAddress_1))];
                case 13: return [4 /*yield*/, ((_e = (_g.sent())) === null || _e === void 0 ? void 0 : _e.json())];
                case 14:
                    addWalletToIndexer = _g.sent();
                    _g.label = 15;
                case 15:
                    if (!newSolanaWalletRes) return [3 /*break*/, 19];
                    parsedRes = JSON.parse(newSolanaWalletRes.response);
                    console.log('parsedRes: ', parsedRes);
                    solanaCiphertext_1 = parsedRes.ciphertext;
                    solanaDataToEncryptHash_1 = parsedRes.dataToEncryptHash;
                    return [4 /*yield*/, createDBEncryptedWallet({
                            pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                            type: 'Solana',
                            address: solanaAddress_1,
                            ciphertext: solanaCiphertext_1,
                            data_to_encrypt_hash: solanaDataToEncryptHash_1,
                            imported: false,
                        })];
                case 16:
                    createDbEncryptedWallet = _g.sent();
                    console.log('solana wallet saved to db', createDbEncryptedWallet);
                    hasEncryptedSolanaWallet_1 = createDbEncryptedWallet === null || createDbEncryptedWallet === void 0 ? void 0 : createDbEncryptedWallet.data;
                    return [4 /*yield*/, fetch("".concat(getUrls().INDEXER_URL, "/portfolio/start-tracking?wallet=").concat(solanaAddress_1))];
                case 17: return [4 /*yield*/, ((_f = (_g.sent())) === null || _f === void 0 ? void 0 : _f.json())];
                case 18:
                    addWalletToIndexer = _g.sent();
                    _g.label = 19;
                case 19:
                    console.log('solanaAddress', solanaAddress_1, 'solanaCiphertext', solanaCiphertext_1, 'solanaDataToEncryptHash', solanaDataToEncryptHash_1, 'evmAddress', evmAddress_1, 'evmCiphertext', evmCiphertext_1, 'evmDataToEncryptHash', evmDataToEncryptHash_1, 'hasSessionSigs', Boolean(sessionSigs));
                    setDecryptedWallets(function (prev) {
                        return [hasEncryptedEvmWallet_1, hasEncryptedSolanaWallet_1];
                    });
                    console.log('WUJI, encrypted wallets time', Date.now() - startime0);
                    setProgressBar(function (prev) { return 85; });
                    startime0 = Date.now();
                    if (!sessionSigs) return [3 /*break*/, 24];
                    setPKP(function (prev) {
                        var updateObject = __assign(__assign({}, prev), { solanaAddress: solanaAddress_1 || (hasEncryptedSolanaWallet_1 === null || hasEncryptedSolanaWallet_1 === void 0 ? void 0 : hasEncryptedSolanaWallet_1.address), ciphertext: solanaCiphertext_1 || (hasEncryptedSolanaWallet_1 === null || hasEncryptedSolanaWallet_1 === void 0 ? void 0 : hasEncryptedSolanaWallet_1.ciphertext), dataToEncryptHash: solanaDataToEncryptHash_1 || (hasEncryptedSolanaWallet_1 === null || hasEncryptedSolanaWallet_1 === void 0 ? void 0 : hasEncryptedSolanaWallet_1.data_to_encrypt_hash), additionalEthAddress: evmAddress_1 || (hasEncryptedEvmWallet_1 === null || hasEncryptedEvmWallet_1 === void 0 ? void 0 : hasEncryptedEvmWallet_1.address), additionalEthAddressCiphertext: evmCiphertext_1 || (hasEncryptedEvmWallet_1 === null || hasEncryptedEvmWallet_1 === void 0 ? void 0 : hasEncryptedEvmWallet_1.ciphertext), additionalEthAddressDataToEncryptHash: evmDataToEncryptHash_1 || (hasEncryptedEvmWallet_1 === null || hasEncryptedEvmWallet_1 === void 0 ? void 0 : hasEncryptedEvmWallet_1.data_to_encrypt_hash) });
                        console.log(' setting PKP to', updateObject, 'hasEncryptedEvmWallet');
                        return updateObject;
                    });
                    console.log('WUJI decrypt auth wallet time', Date.now() - startime0);
                    startime0 = Date.now();
                    _g.label = 20;
                case 20:
                    _g.trys.push([20, 22, , 23]);
                    //sets cached signature to local storage
                    setProgressBar(function (prev) { return 90; });
                    console.log('WUJI setting local storage to start decryption');
                    //these will skip the signature and just decrypt because the signature is already cached in local storage
                    setStartDecryption(true);
                    backupEVMBackupKeyToLitPromise = function () { return __awaiter(_this, void 0, void 0, function () {
                        var backupEVMBackupKeyToLit_1, e_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, storeEncryptedKey({
                                            pkpSessionSigs: sessionSigs0_1,
                                            litNodeClient: clients.litNodeClient,
                                            //base64 encode
                                            ciphertext: Buffer.from(hasEncryptedEvmWallet_1.ciphertext).toString('base64'),
                                            dataToEncryptHash: hasEncryptedEvmWallet_1.data_to_encrypt_hash,
                                            publicKey: pkp.publicKey,
                                            keyType: 'K256',
                                            memo: 'Genius EVM Backup',
                                        })];
                                case 1:
                                    backupEVMBackupKeyToLit_1 = _a.sent();
                                    console.log('backupEVMBackupKeyToLit', backupEVMBackupKeyToLit_1, 'time');
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_3 = _a.sent();
                                    console.log('error backing up KeyToLit EVM', e_3);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    backupSolanaBackupKeyToLitPromise = function () { return __awaiter(_this, void 0, void 0, function () {
                        var backupSolanaBackupKeyToLit_1, e_4;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, storeEncryptedKey({
                                            pkpSessionSigs: sessionSigs0_1,
                                            litNodeClient: clients.litNodeClient,
                                            //base64 encode
                                            ciphertext: hasEncryptedSolanaWallet_1.ciphertext,
                                            dataToEncryptHash: hasEncryptedSolanaWallet_1.data_to_encrypt_hash,
                                            publicKey: pkp.publicKey,
                                            keyType: 'ed25519',
                                            memo: 'Genius Solana Backup',
                                        })];
                                case 1:
                                    backupSolanaBackupKeyToLit_1 = _a.sent();
                                    console.log('backupSolanaBackupKeyToLit', backupSolanaBackupKeyToLit_1, 'time');
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_4 = _a.sent();
                                    console.log('error backing up KeyToLit Solana', e_4);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    return [4 /*yield*/, Promise.all([
                            backupEVMBackupKeyToLitPromise(),
                            backupSolanaBackupKeyToLitPromise(),
                        ])];
                case 21:
                    _b = _g.sent(), backupEVMBackupKeyToLit = _b[0], backupSolanaBackupKeyToLit = _b[1];
                    console.log('WUJI decrypt backup time', Date.now() - startime0);
                    return [3 /*break*/, 23];
                case 22:
                    e_2 = _g.sent();
                    console.log('error backing up KeyToLit', e_2);
                    return [3 /*break*/, 23];
                case 23: return [3 /*break*/, 25];
                case 24:
                    toast('Error creating session!', {
                        position: 'bottom-right',
                        description: 'If this error persists, please contact support at support@tradegenius.com',
                    });
                    _g.label = 25;
                case 25:
                    setProgressBar(function (prev) { return 99; });
                    return [2 /*return*/, sessionSigs];
                case 26:
                    err_3 = _g.sent();
                    console.log('WUJI CREATE SESSION ERROR', err_3);
                    slackLogger({
                        type: 'APPLICATION_ERROR',
                        payload: {
                            type: 'CREATE_SESSION_ERROR',
                            error: err_3.message,
                            stack: err_3.stack,
                            pkp: pkp,
                        },
                    });
                    LogToMixpanel({
                        category: CATEGORIES.error,
                        eventName: EVENTS.error.authError,
                        pkp: pkp,
                        metaData: {
                            type: 'CREATE_SESSION_ERROR',
                            error: err_3.message,
                            stack: err_3.stack,
                            pkp: pkp,
                        }
                    });
                    return [3 /*break*/, 28];
                case 27:
                    setLoading(false);
                    setProgressBar(function (prev) { return 0; });
                    console.log('WUJI CREATE SESSION TIME', Date.now() - startTime);
                    return [7 /*endfinally*/];
                case 28: return [2 /*return*/, null];
            }
        });
    }); };
    //automatically create a session after minting a PKP or when pkps are loaded
    return {
        authIn: authIn,
        mint: mint,
        createSession: createSession,
        handleRedirect: handleRedirect,
        loading: loading,
        progressBar: progressBar,
    };
}
//https://developer.litprotocol.com/sdk/wallets/auth-methods/custom-auth
export var STATE_PARAM_KEY = 'lit-state-param';
